import classNames from "classnames";
import React from "react";

interface Props {
  className?: string;
}

export const Center = (props: React.PropsWithChildren<Props>) => (
  <div className={classNames("Center", props.className)}>{props.children}</div>
);
